import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import FamilyShell from "../../components/family/FamilyShell";

const API = process.env.REACT_APP_API_URL;

export default function FamilyHomePage() {
  const [patients, setPatients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const res = await fetch(`${API}/family/me/patients`, {
          credentials: "include",
        });
        const data = await res.json().catch(() => []);
        if (!alive) return;
        if (!res.ok) throw new Error(data?.error || "Angehoerige konnten nicht geladen werden.");
        setPatients(Array.isArray(data) ? data : []);
      } catch (error) {
        if (!alive) return;
        setErr(error?.message || "Angehoerige konnten nicht geladen werden.");
      } finally {
        if (!alive) return;
        setLoading(false);
      }
    })();
    return () => {
      alive = false;
    };
  }, []);

  return (
    <FamilyShell title="Meine Angehoerigen">
      {loading ? <p className="text-sm text-gray-600">Bewohner werden geladen...</p> : null}
      {err ? (
        <div className="rounded-2xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
          {err}
        </div>
      ) : null}

      {!loading && !err && patients.length === 0 ? (
        <div className="rounded-3xl border border-black/10 bg-white/80 p-6 shadow-sm">
          <h2 className="text-xl font-semibold text-gray-900">Noch keine Verknuepfungen</h2>
          <p className="mt-2 text-sm text-gray-600">
            Sobald du eingeladen wurdest, erscheinen hier die verknuepften Bewohner.
          </p>
        </div>
      ) : null}

      {!loading && !err && patients.length > 0 ? (
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          {patients.map((patient) => (
            <Link
              key={patient.id}
              to={`/family/patients/${patient.id}`}
              className="rounded-3xl border border-black/10 bg-white/80 p-6 shadow-sm transition hover:-translate-y-0.5 hover:bg-white"
            >
              <p className="text-sm font-medium text-blue-700">
                {patient.relationship_label || "Familienzugang"}
              </p>
              <h2 className="mt-2 text-2xl font-semibold text-gray-900">
                {patient.forename} {patient.surname}
              </h2>
              <p className="mt-3 text-sm text-gray-600">Profil, Kalender, Erinnerungen und Feed</p>
            </Link>
          ))}
        </div>
      ) : null}
    </FamilyShell>
  );
}
